import { render } from "./AppCarrusel.vue?vue&type=template&id=03138fc4&scoped=true"
import script from "./AppCarrusel.vue?vue&type=script&lang=js"
export * from "./AppCarrusel.vue?vue&type=script&lang=js"

import "./AppCarrusel.vue?vue&type=style&index=0&id=03138fc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03138fc4"]])

export default __exports__